// extracted by mini-css-extract-plugin
export var button = "_fi-2";
export var card = "_fi-0";
export var closeButtonContainer = "_fi-3";
export var iconContainer = "_fi-1";